import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { JwtService } from "app/generic/JwtService";
import { NewModalService } from "app/generic/new-modal/new-modal.service";
import { environment } from "environments/environment";

@Injectable({
  providedIn: 'root'
})
export class LandingPageService extends JwtService {

  constructor(private http: HttpClient,
    public router: Router,
    public modalComponent: NewModalService) {
    super(router, modalComponent);
  }

  selectAll(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findLastAllerta', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllOggi(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findLastAllertaNew', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  selectAllDomani(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findAllertaDomaniNew', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }
  findAllDescrizione(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/extra/findAll', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }
  findExtraById(idExtraAsset): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/extra/findById/'+idExtraAsset, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

}
